<rid-mechanic-background />

<rid-mechanic-wrapper>
  <rid-top-bar [progress]="index()" [steps]="numbers().length" class="block w-full" name="Flits hoeveelheid" />

  <rid-mechanic-content>
    <div class="grid place-items-center">
      @if (state() === 'VISIBLE' || state() === 'ANSWER') {
        @for (num of [number()]; track num) {
          @if (state() === 'ANSWER') {
            <h1
              animate.enter="wait-300 anim-pop-in"
              animate.leave="anim-fade-out"
              class="font-family-din pb-8 text-6xl font-black text-emerald-500 drop-shadow-2xl"
            >
              {{ num }}
            </h1>
          }

          <rid-egg-cartons [eggs]="num" animate.enter="wait-300 anim-pop-in" animate.leave="anim-fade-out" />
        }
      }
    </div>

    @if (state() === 'ANSWER') {
      <rid-assessment-toast (assessed)="$event === 'CORRECT' ? markCorrect() : markIncorrect()" />
    }
  </rid-mechanic-content>
</rid-mechanic-wrapper>
